import React, { useEffect, useRef } from 'react';

const GOOGLE_MAPS_API_KEY = 'AIzaSyBYafO0ZNP_lJHGSJ4zy6stPMfQpb_7Nok';

const CONFIGURATION = {
    locations: [
        {
            title: "White Valley Cafe & Multicuisine Restaurant",
            address1: "Dharamshi Korat Road",
            address2: "Rajkot, Gujarat, India",
            coords: { lat: 22.2748993, lng: 70.7519847 },
            placeId: "ChIJkQajGQDLWTkRyl1Ys_4n5rk",
            actions: [
                { label: "Order online", defaultUrl: "https://www.zomato.com/rajkot/white-valley-mota-mava/order" }
            ]
        }
    ],
    mapOptions: {
        center: { lat: 22.2748993, lng: 70.7519847 },
        fullscreenControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        zoom: 15,
        zoomControl: true,
        maxZoom: 17,
        mapId: ""
    },
    mapsApiKey: GOOGLE_MAPS_API_KEY,
    capabilities: {
        input: true,
        autocomplete: true,
        directions: true,
        distanceMatrix: true,
        details: true,
        actions: true
    }
};

const StoreLocator = () => {
    const containerRef = useRef(null);
    const initialized = useRef(false);

    useEffect(() => {
        if (initialized.current || !containerRef.current) return;
        initialized.current = true;

        // Create the HTML structure for store locator
        // Using innerHTML because React's "key" prop conflicts with gmpx-api-loader's "key" attribute
        containerRef.current.innerHTML = `
      <gmpx-api-loader key="${GOOGLE_MAPS_API_KEY}" solution-channel="GMP_QB_locatorplus_v11_cABCDEF"></gmpx-api-loader>
      <gmpx-store-locator map-id="DEMO_MAP_ID"></gmpx-store-locator>
    `;

        // Load the Extended Component Library script
        const existingScript = document.querySelector('script[src*="extended-component-library"]');
        if (!existingScript) {
            const script = document.createElement('script');
            script.type = 'module';
            script.src = 'https://ajax.googleapis.com/ajax/libs/@googlemaps/extended-component-library/0.6.11/index.min.js';
            document.head.appendChild(script);
        }

        // Configure the locator once loaded
        const configureLocator = async () => {
            try {
                await customElements.whenDefined('gmpx-store-locator');
                const locator = containerRef.current?.querySelector('gmpx-store-locator');
                if (locator) {
                    locator.configureFromQuickBuilder(CONFIGURATION);
                }
            } catch (error) {
                console.error('Store Locator initialization error:', error);
            }
        };

        // Wait for custom elements to be defined
        const checkAndConfigure = () => {
            if (customElements.get('gmpx-store-locator')) {
                configureLocator();
            } else {
                setTimeout(checkAndConfigure, 200);
            }
        };

        setTimeout(checkAndConfigure, 500);
    }, []);

    return (
        <>
            <style>{`
        .store-locator-wrapper {
          width: 100%;
          height: 500px;
        }
        .store-locator-wrapper gmpx-store-locator {
          width: 100%;
          height: 100%;
          display: block;
          --gmpx-color-surface: #fff;
          --gmpx-color-on-surface: #212121;
          --gmpx-color-on-surface-variant: #757575;
          --gmpx-color-primary: #D4A574;
          --gmpx-color-outline: #e0e0e0;
          --gmpx-fixed-panel-width-row-layout: 28.5em;
          --gmpx-fixed-panel-height-column-layout: 65%;
          --gmpx-font-family-base: "Inter", sans-serif;
          --gmpx-font-family-headings: "Cormorant Garamond", serif;
          --gmpx-font-size-base: 0.875rem;
          --gmpx-hours-color-open: #188038;
          --gmpx-hours-color-closed: #d50000;
          --gmpx-rating-color: #ffb300;
          --gmpx-rating-color-empty: #e0e0e0;
        }
      `}</style>
            <div
                ref={containerRef}
                className="store-locator-wrapper"
            />
        </>
    );
};

export default StoreLocator;
